module.exports = __webpack_public_path__ + "img/img-warning-modal.png";